import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ReactInputMask from "react-input-mask";
import { isMobile } from "react-device-detect";

import section2WomanPresenting from "../../images/womanPresenting.jpg";
import section3People from "../../images/franchiseSection3People.png";
import mouseImage from "../../images/Icons/mouseIcon.svg";

import S2topUnion1 from "./images/section2/S2TopUnion1.png";
import S2topUnion2 from "./images/section2/S2TopUnion2.png";
import S2topUnion3 from "./images/section2/S2TopUnion3.png";
import S2middleUnion from "./images/section2/S2MiddleUnion.png";
import S2bottonUnion1 from "./images/section2/S2BottomUnion1.png";
import S2bottonUnion2 from "./images/section2/S2BottomUnion2.png";
import S2bottonUnion3 from "./images/section2/S2BottomUnion3.png";

import S3leftTopUnion from "./images/section3/S3LeftTopUnion.png";
import S3rightTopUnion from "./images/section3/S3RightTopUnion.png";
import S3topMiddleUnion from "./images/section3/S3TopMiddleUnion.png";
import S3middleUnion from "./images/section3/S3MiddleUnion.png";
import S3middleBottomUnion from "./images/section3/S3MiddleBottomUnion.png";
import S3rightBottomUnion from "./images/section3/S3RightBottomUnion.png";

import Fancybox from "../../components/fancybox/fancybox";

import "./be-franchise.scss";

const schema = yup
  .object({
    nome: yup.string().required("Nome é uma informação obrigatória!"),
    email: yup
      .string()
      .required("Email é uma informação obrigatória!")
      .email("Email não está em um formato válido!"),
    telefone: yup
      .string()
      .required("O telefone é obrigatório!")
      .matches(/\(\d{2}\)\s\d{5}-\d{4}/, "Formato de telefone inválido!"),
    mensagem: yup.string().required("Mensagem é uma informação obrigatória!"),
  })
  .required();

function BeFranchise() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <div className="be-franchise">
      <section className={`section-1 ${isMobile ? "mobile" : ""}`}>
        <div className="content">
          <div className="container-fluid">
            <div className="container">
              <div className="texts">
                <h4>Invista na economia sustentável</h4>
                <h1>O sucesso do futuro se constrói no presente!</h1>
                <p>
                  Buscamos empreendedores que anseiam sucesso, que estejam
                  comprometidos em aprender a gestão da operação, que possuam um
                  bom relacionamento interpessoal e liderança com sua equipe,
                  tendo a franquia como seu principal negócio.
                </p>

                <img className="pt-2" src={mouseImage} alt="MouseImage" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={`section-2 ${isMobile ? "mobile" : ""}`}>
        <img className="background-image" src={S2topUnion1} alt="Imagem" />
        <img className="background-image" src={S2topUnion2} alt="Imagem" />
        <img className="background-image" src={S2topUnion3} alt="Imagem" />
        <img className="background-image" src={S2middleUnion} alt="Imagem" />
        <img className="background-image" src={S2bottonUnion1} alt="Imagem" />
        <img className="background-image" src={S2bottonUnion2} alt="Imagem" />
        <img className="background-image" src={S2bottonUnion3} alt="Imagem" />
        <div className="container-fluid h-100">
          <div
            className={`container h-100 d-flex ${
              isMobile ? "flex-column" : ""
            } justify-content-between`}
          >
            <div className="people-image">
              <Fancybox>
                <a
                  href="apresentacao-adoleta-aluguel-de-brinquedos.mp4"
                  data-fancybox
                >
                  <img
                    className="img-fluid"
                    src={section2WomanPresenting}
                    alt="Mulher apresentando"
                  />
                </a>
              </Fancybox>
            </div>
            <div className="texts">
              <h4>
                EMPREENDER NA ADOLETA É JUNTAR DIVERSÃO, EMPATIA, PRODUTIVIDADE
                E RENTABILIDADE.
              </h4>
              <h1 className="mb-4">
                Seja um franqueado e faça parte do nosso time
              </h1>

              <p className="mb-4">
                Quer estar à frente de uma excelente empresa, investindo pouco e
                trabalhando em casa? A Adoleta é a empresa certa para você!
                Baixo investimento e consultoria permanente. Nós te passamos
                todo o treinamento necessário.
              </p>
              <p className="mb-4">
                Nossos brinquedos e acessórios são selecionados a dedo, baseados
                na experiência do mercado de aluguel. Rentáveis e de fácil
                locação, eles possuem alta rotatividade e grande demanda.{" "}
                <strong>Então vem investir em uma marca de sucesso.</strong>
              </p>

              <p className="mb-4 label-title">Benefícios do franqueado:</p>
              <ul>
                <li>Capacitação e aplicação de treinamentos;</li>
                <li>Suporte ao franqueado;</li>
                <li>
                  Orientação durante todo o processo de abertura da empresa;
                </li>
                <li>Site para aluguel online;</li>
                <li>
                  Acesso aos produtos que estão em alta no mercado infantil.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className={`section-3 ${isMobile ? "mobile" : ""}`}>
        <img className="background-image" src={S3leftTopUnion} alt="Imagem" />
        <img className="background-image" src={S3topMiddleUnion} alt="Imagem" />
        <img className="background-image" src={S3rightTopUnion} alt="Imagem" />
        <img className="background-image" src={S3middleUnion} alt="Imagem" />
        <img
          className="background-image"
          src={S3middleBottomUnion}
          alt="Imagem"
        />
        <img
          className="background-image"
          src={S3rightBottomUnion}
          alt="Imagem"
        />
        <div className="container-fluid h-100">
          <div
            className={`container h-100 d-flex ${
              isMobile ? "flex-column" : ""
            } justify-content-between`}
          >
            <div className="texts">
              <h4>
                EMPREENDA NA MELHOR EMPRESA DE ALUGUEL DE BRINQUEDOS DO BRASIL
              </h4>
              <h1>Conheça as vantagens em ser um franqueado</h1>

              <p className="title-label">
                <strong>Setor em crescimento</strong>
              </p>
              <p className="mb-4">
                O compartilhamento de acessórios e brinquedos está em alta,
                devido a necessidade de distrações das crianças em casa,
                tornando-se um modelo de negócio ainda mais favorável para o
                empreendedor.
              </p>

              <p className="title-label">
                <strong>Econimia sustentável</strong>
              </p>
              <p className="mb-4">
                A reutilização de brinquedos tem ganhado cada vez mais
                visibilidade no mercado e nos negócios, proporcionando uma
                economia de quase 80% referente ao valor de um produto novo.
              </p>

              <p className="title-label">
                <strong>Oportunidade de trabalhar em casa</strong>
              </p>
              <p className="mb-4">
                Em home office você tem disponibilidade para passar mais tempo
                com os filhos e a família, desenvolve uma produtividade melhor
                de trabalho e ganha muito mais flexibilidade nas rotinas e
                horários.
              </p>
              <p>Cadastre-se já e seja bem vindo (a) à família Adoleta!</p>
            </div>
            <div className="people-image">
              <img className="img-fluid" src={section3People} alt="Imagem" />
            </div>
          </div>
        </div>
      </section>
      <section className={`section-4 ${isMobile ? "mobile" : ""}`}>
        <div className="container-fluid">
          <div className="container d-flex flex-column align-items-center justify-content-center">
            <div className="titles text-center">
              <h4>FAÇA SEU PRÉ-CADASTRO</h4>
              <h1>Preencha o formulário abaixo, para ser um franqueado.</h1>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="w-100 form">
              <div className="mb-3">
                <label htmlFor="nome" className="form-label">
                  Nome
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="nome"
                  placeholder="Seu nome completo"
                  {...register("nome")}
                />
                {errors.nome ? (
                  <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                    </svg>
                    <p>{errors.nome.message}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="telefone" className="form-label">
                  Telefone
                </label>
                <ReactInputMask
                  className="form-control"
                  mask="(99) 99999-9999"
                  placeholder="DDD + Celular"
                  maskChar={null}
                  {...register("telefone")}
                >
                  {(inputProps) => <input {...inputProps} />}
                </ReactInputMask>
                {errors.telefone ? (
                  <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                    </svg>
                    <p>{errors.telefone.message}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email address
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  placeholder="Digite seu e-mail"
                  {...register("email")}
                />
                {errors.email ? (
                  <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                    </svg>
                    <p>{errors.email.message}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="mensagem" className="form-label">
                  Mensagem
                </label>
                <textarea
                  className="form-control form-textarea"
                  placeholder="Digite sua mensagem"
                  id="mensagem"
                  {...register("mensagem")}
                ></textarea>
                {errors.mensagem ? (
                  <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                    </svg>
                    <p>{errors.mensagem.message}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mt-4 d-flex justify-content-center">
                <button type="submit" className="btn button-control">
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BeFranchise;
